import React, { ReactElement, ReactNode, RefObject } from 'react'

type FieldsetProps = {
    children: ReactNode
    className?: string
    popoverRef?: RefObject<HTMLDivElement>
}

const Fieldset: React.FC<FieldsetProps> = ({ children, className, popoverRef }: FieldsetProps): ReactElement => (
    <div className={`fieldset ${className ?? ''}`} ref={popoverRef}>
        {children}
    </div>
)

export default Fieldset
